import ActionTypes from "../../enums/ActionTypes"

export default function (state = {}, action) {
  switch (action.type) {
    case ActionTypes.LICENCE_MODULES_ADD_FAILURE: {
      const errorCode = action.payload.response?.errorCode || "unknown"
      return {
        ...state,
        errorCode,
        pending: false,
      }
    }
    case ActionTypes.LICENCE_MODULES_ADD_REQUEST: {
      return { ...state, errorCode: null, pending: true } 
    }
    case ActionTypes.LICENCE_MODULES_ADD_SUCCESS: {
      return { ...state, errorCode: null, pending: false }
    }
    case ActionTypes.LICENCE_MODULES_ADD_FORM_ERROR_RESET: {
      return { ...state, errorCode: null, pending: false }
    }
    default:
      return state
  }
}
